module.exports = __webpack_public_path__ + "img/no-image.c5f4bdf7.svg";